import type { ReactElement } from 'react';
import type { AttachmentErrorProps } from '../types';
import { AttachmentIcon } from '../shared/icon';
import { Layout } from '../shared/layout';
import { Subtitle } from '../shared/subtitle';
import { Title } from '../shared/title';
import styles from './error.module.css';

export function AttachmentError({
  className,
  endContent,
  fileUrl,
  title,
  subtitle,
  icon,
  thumbnail,
  thumbnailAlt,
  onPreview,
  onRemove,
  ...props
}: AttachmentErrorProps): ReactElement {
  return (
    <Layout
      className={className}
      data-testid="attachment-error"
      endContent={endContent}
      icon={
        <AttachmentIcon
          className={styles.icon}
          fileUrl={fileUrl}
          icon={icon}
          onPreview={onPreview}
          thumbnail={thumbnail}
          thumbnailAlt={thumbnailAlt}
        />
      }
      onRemove={onRemove}
      {...props}
    >
      <Title onPreview={onPreview}>{title}</Title>
      <Subtitle className={styles.subtitle}>{subtitle}</Subtitle>
    </Layout>
  );
}
